// extracted by mini-css-extract-plugin
export default {"cards":"UserReviews_cards__SR62c"};